import { Routes, Route } from "react-router-dom";
import { LOGIN,LOGOUT } from "../constants/routes";
import LoginScreen from "../screens/LoginScreen";
import LogoutScreen from "../screens/LogoutScreen";

const AuthRouter = () => {
  return (
    <Routes>
      <Route path={'/'} element={<LoginScreen />} />
      <Route path={LOGIN} element={<LoginScreen />} />
      <Route path={LOGOUT} element={<LogoutScreen />} />
    </Routes>
  );
};

export default AuthRouter;
